var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-base-application',{attrs:{"title":"Fairgrit 利用料金の確認","icon":"fas fa-cogs"}},[_c('billing-settings')],1)}
var staticRenderFns = []

export { render, staticRenderFns }